import UUIDBase from './UUIDBase'

export const petI18nMessages = {
  en: {
    pets: 'Pets',
    pet: 'Pet',
    petName: 'Pet Name',
    dateOfBirth: 'Date of Birth',
    type: 'Type',
    sex: 'Sex',
    breed: 'Breed',
    male: 'Male',
    female: 'Female',
    ownerName: 'Owner Name',
    ownerId: 'Owner ID',
    selectPet: 'Select a pet',
    selectOwner: 'Select Owner',
    newPet: 'New Pet',
    editPet: 'Edit Pet',
    viewPet: 'View Pet',
    deletePet: 'Delete Pet',
    dog: 'Dog',
    cat: 'Cat',
    bird: 'Bird',
    rabbit: 'Rabbit',
    other: 'Other',
    color: 'Color',
    neutered: 'Neutered?'
  },
  ar: {
    pets: 'الحيوانات الأليفة',
    pet: 'أليف',
    petName: 'اسم الأليف',
    dateOfBirth: 'تاريخ الميلاد',
    type: 'النوع',
    sex: 'الجنس',
    breed: 'السلالة',
    male: 'ذكر',
    female: 'أنثى',
    ownerName: 'اسم المالك',
    ownerId: 'رقم المالك',
    selectPet: 'اختر أليف',
    selectOwner: 'اختر المالك',
    newPet: 'أليف جديد',
    editPet: 'تعديل أليف',
    viewPet: 'عرض أليف',
    deletePet: 'حذف أليف',
    dog: 'كلب',
    cat: 'قطة',
    bird: 'طائر',
    rabbit: 'أرنب',
    other: 'أخرى',
    color: 'اللون',
    neutered: 'معقم؟'
  }
}

export interface PetsPaginated {
  data: Array<Pet>,
  total: number
}

export interface PetCustomer {
  id: string
  name: string
  businessName: string
  email: string
  phone: string
}

export default class Pet extends UUIDBase {
  static from(json: Record<string, unknown> | Pet) {
    return Object.assign(new Pet(), json)
  }
  static ENDPOINT = '/customer/pets'

  name = ''
  dateOfBirth: Date | null = null
  type = ''
  sex = ''
  breed = ''
  color = ''
  neutered = false
  customerID = ''
  customer: PetCustomer | null = null
  isDeleted = false

  get displayName() {
    return `${this.name} (${this.type})`
  }

  get customerName() {
    return this.customer?.name || ''
  }
}
